// Single source of truth for Danish URLs
export const URLS = {
  FRONT_PAGE: '/',
  LOGIN: '/log-ind/',
  REGISTER: '/opret-konto/',
  FORGOT_PASSWORD: '/glemt-adgangskode/',
  RESET_PASSWORD: '/nulstil-adgangskode/',
  MY_PROFILE: '/min-konto/min-profil/',
  MY_CONTACTS: '/min-konto/mine-kontakter/',
  MY_INVITATIONS: '/min-konto/mine-invitationer/',
  MY_ORDERS: '/min-konto/mine-ordrer/',
  MY_FAVORITES: '/min-konto/mine-favoritter/',
  CREATE_INVITATION: '/opret-invitation/',
  SUPPORT: '/support/',
  FAQ: '/faq/',
  
  // Invitation design flow base path
  DESIGN_FLOW_BASE: '/min-konto/invitation/designtrin/',
  
  // Invitation design flow URLs
  SELECT_DESIGN: '/min-konto/invitation/designtrin/vaelg-design/',
  EDIT_CARD: '/min-konto/invitation/designtrin/rediger-kort/',
  ENVELOPE: '/min-konto/invitation/designtrin/konvolut/',
  BACKGROUND: '/min-konto/invitation/designtrin/baggrund/',
  INVITATION_DETAILS: '/min-konto/invitation/detaljer/',
  INVITATION_SEND: '/min-konto/invitation/send/',
} as const;

// Static page IDs for Gatsby filesystem pages (not from WordPress)
export const STATIC_PAGE_IDS = {
  [URLS.FRONT_PAGE]: 'front-page',
  [URLS.LOGIN]: 'login',
  [URLS.REGISTER]: 'register', 
  [URLS.FORGOT_PASSWORD]: 'forgot-password',
  [URLS.RESET_PASSWORD]: 'reset-password',
  [URLS.MY_PROFILE]: 'my-profile',
  [URLS.MY_CONTACTS]: 'my-contacts',
  [URLS.MY_INVITATIONS]: 'my-invitations',
  [URLS.MY_ORDERS]: 'my-orders',
  [URLS.MY_FAVORITES]: 'my-favorites',
  [URLS.CREATE_INVITATION]: 'create-invitation',
  
  // Invitation design flow page IDs
  [URLS.SELECT_DESIGN]: 'select-design',
  [URLS.EDIT_CARD]: 'edit-card',
  [URLS.ENVELOPE]: 'envelope',
  [URLS.BACKGROUND]: 'background',
  [URLS.INVITATION_DETAILS]: 'invitation-details',
  [URLS.INVITATION_SEND]: 'invitation-send',
  
  '/404/': '404',
  '/email-confirmation/': 'email-confirmation',
} as const;

const PROJECT_FLOW_PAGES = [
  URLS.SELECT_DESIGN,
  URLS.EDIT_CARD,
  URLS.ENVELOPE,
  URLS.BACKGROUND,
  URLS.INVITATION_DETAILS,
  URLS.INVITATION_SEND,
] as const;

/** Returns true only if the path belongs to the invitation project flow (design steps, details, send). */
export const isValidFlowPage = (page: string | null | undefined): page is string =>
  !!page && PROJECT_FLOW_PAGES.some(flowPage => page.startsWith(flowPage));

// Helper function to get page ID from current path
export const getPageIdFromPath = (pathname: string): string | number | undefined => {
  // Clean up pathname (remove trailing slashes for consistency)
  const cleanPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
  
  // Check if it's a static Gatsby page
  if (cleanPath in STATIC_PAGE_IDS) {
    return STATIC_PAGE_IDS[cleanPath as keyof typeof STATIC_PAGE_IDS];
  }

  // Prefix matching for category sub-pages (e.g. /opret-invitation/bryllup/)
  if (cleanPath.startsWith(URLS.CREATE_INVITATION) && cleanPath !== URLS.CREATE_INVITATION) {
    return 'create-invitation';
  }
  if (cleanPath.startsWith(URLS.SELECT_DESIGN) && cleanPath !== URLS.SELECT_DESIGN) {
    return 'select-design';
  }
  
  // Return undefined for WordPress pages (they'll use their databaseId)
  return undefined;
};
